import fileSaver from 'file-saver';
import * as ProductListService from '../../../../services/ProductList.services';
import ProductListType from './ProductList.type';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import * as SystemMasterServices from '../../../../services/SystemMaster.services';
import * as SupplierService from '../../../../services/supplier.service';
import * as OrderPermissionService from '../../../../services/order-permission.service';
import * as BomLibraryService from '../../../../services/bom-library.service';
import { ERROR_MESSAGE } from '../../../../Components/helper';

export const fetchProductList = (params) => async (dispatch) => {
  try {
    const res = await ProductListService.getProductList(params);
    if (res.code === 200 && res.data) {
      await dispatch({
        type: ProductListType.RANGEPLANPRODUCT,
        payload: {
          data: res.data.doc,
          totalCount: res.data.totalCount,
          isScrolled: params.isScrolled,
        },
      });
    } else {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
  } catch (err) {
    console.log(err.toString(), err);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return true;
};

export const fetchProductInfoTabDetails = (params, key) => async (dispatch) => {
  try {
    const res = await ProductListService.getProductTabsList(params);
    if (res.code === 200 && res.data) {
      await dispatch({
        type: ProductListType.PRODUCT_TAB_LIST,
        payload: { data: res.data, params, key },
      });
      return true;
    }
    if (res.code === 500) {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
    return true;
  }
};

export const addRangePlanProductInfo = (data, transactionMsg) => async () => {
  try {
    const res = await ProductListService.addRangePlanProductInfoService(data);
    if (res.code === 200) {
      toasterMsg(transactionMsg('Product info updated successfully'), 'success');
      return true;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setFilterSelection = (data) => async (dispatch) => {
  try {
    await dispatch({
      type: ProductListType.SET_FILTERDATA,
      payload: data,
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const updateProductList = (data) => async (dispatch) => {
  try {
    await dispatch({
      type: ProductListType.UPDATE_PRODUCTLIST,
      payload: data,
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSampleTrackingDetails = () => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllSampleTracking();
    if (res.code === 200) {
      await dispatch({
        type: ProductListType.GET_SAMPLE_TRACKING_PRODUCT_LISTING,
        payload: res.data,
      });
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSystemMeasurement = () => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllMeasurement();
    if (res.code === 200) {
      await dispatch({
        type: ProductListType.SET_MEASUREMENT_SYSTEM_MASTER,
        payload: res.data,
      });
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getCustomSectionData = (params) => async (dispatch) => {
  try {
    const res = await ProductListService.getCustomSectionDataService(params);
    if (res.code === 200 && res.data?.success !== false) {
      dispatch({
        type: ProductListType.GET_CUSTOM_SECTION_DATA,
        payload: {
          data: res.data.data || [],
          totalProducts: res.data.totalProducts || 0,
          totalCount: res.data.totalCount || 0,
          customSectionDetails: res.data.customSectionDetails || [],
        },
      });
      return res;
    }
    dispatch({
      type: ProductListType.GET_CUSTOM_SECTION_DATA_ERROR,
      payload: { sectionId: params?.sectionId },
    });
    toasterMsg(res?.data?.errMsg || res?.data?.error || ERROR_MESSAGE, 'danger');
    return res;
  } catch (error) {
    console.log(error.message);
    dispatch({
      type: ProductListType.GET_CUSTOM_SECTION_DATA_ERROR,
      payload: { sectionId: params?.sectionId },
    });
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchCustomSections = (params) => async (dispatch) => {
  try {
    const res = await ProductListService.fetchCustomSectionsService(params);
    if (res.code === 200) {
      await dispatch({
        type: ProductListType.SET_CRITICAL_PATH_CUSTOM_SECTIONS,
        payload: res.data,
      });
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getAllSectionColumns = (params) => async (dispatch) => {
  try {
    const res = await ProductListService.getAllSectionColumnsService(params);
    if (res.code === 200) {
      dispatch({
        type: ProductListType.GET_ALL_SECTION_COLUMNS,
        payload: res.data || [],
      });
      return res;
    }
    if (res.code === 500) {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    return res;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchCategoryAction = (params) => async (dispatch) => {
  try {
    const res = await SupplierService.getAllCategory(params);

    if (res.code === 200 && res.data) {
      await dispatch({
        type: ProductListType.PRODUCT_LIST_CATEGORY,
        payload: { data: res.data, catType: params.categoryType },
      });
    }
    return res;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchAllProductType = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllPCTypes(params);
    if (res.code === 200 && res.data) {
      await dispatch({
        type: ProductListType.PRODUCT_LIST_PRODUCT_TYPE,
        payload: res.data,
      });
      return res;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchBomReferenceSupplier = () => async (dispatch) => {
  try {
    const res = await BomLibraryService.getBomLibraryReferenceSupplier();
    if (res?.code === 200) {
      await dispatch({
        type: ProductListType.PRODUCTLIST_FETCH_REFERENCE_SUPPLIER,
        payload: res.data,
      });
      return res;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getProductStatusDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllProductStatus(params);
    if (res.code === 200) {
      await dispatch({
        type: ProductListType.PRODUCT_LIST_GET_ALL_PRODUCT_STATUS_MASTER,
        payload: res.data,
      });
      return res;
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getCompanyUsers = () => async (dispatch) => {
  try {
    const res = await ProductListService.getCompanyUsersService();
    await dispatch({
      type: ProductListType.PRODUCT_LIST_COMPANY_USERS,
      payload: res.data,
    });
    return res;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getCustomAttributeFreeText = () => async (dispatch) => {
  try {
    const res = await ProductListService.getAllCustomAttribute();
    await dispatch({
      type: ProductListType.PRODUCT_LIST_CUSTOM_ATTRIBUTE_LIST,
      payload: res.data,
    });
    return res;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchMultiList = (params) => async () => {
  try {
    return await ProductListService.fetchMultiListService(params);
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const downloadCostingExportAll = (params, transactionMsg) => async () => {
  try {
    const filterObj = params?.filterObj || {};
    const toArray = (v) => (Array.isArray(v) ? v : v != null ? [v] : []);
    const serviceParams = {
      brandIds: toArray(filterObj.brandId),
      seasonIds: toArray(filterObj.seasonId),
      supplierIds: toArray(filterObj.supplierId),
      searchText: params?.searchText ?? '',
      rangeplanId: params?.rangeplanId ?? '',
      timeZone: params?.timeZone ?? '',
      costingTemplateId: params?.costingTemplateId ?? '',
      year: toArray(filterObj.year),
      month: toArray(filterObj.month),
      catOneId: toArray(filterObj.catOneId),
      catTwoId: toArray(filterObj.catTwoId),
      catThreeId: toArray(filterObj.catThreeId),
      catFourId: toArray(filterObj.catFourId),
      statusId: toArray(filterObj.statusId),
      productType: toArray(filterObj.productType),
      createdBy: toArray(filterObj.createdBy),
      COO: toArray(filterObj.COO),
      productGroupId: filterObj.productGroupId ?? '',
      subBrandId: toArray(filterObj.subBrandId),
      colorGroupId: toArray(filterObj.colorGroupId),
      colorwayId: toArray(filterObj.colorwayId),
      dynamicTypes: Array.isArray(filterObj.dynamicTypes) ? filterObj.dynamicTypes : filterObj.dynamicTypes ?? null,
    };
    const response = await ProductListService.costingExportAllService(serviceParams);
    if (response?.data) {
      const fileName = `Costing_Report_All_${Date.now()}.xlsx`;
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      fileSaver.saveAs(blob, fileName);
      toasterMsg(transactionMsg('Costing report downloaded successfully'), 'success');
    }
  } catch (error) {
    let errMsg = error?.message ?? ERROR_MESSAGE;
    const data = error?.response?.data;
    if (data) {
      if (typeof data === 'object' && !(data instanceof ArrayBuffer) && (data.message || data.errMsg)) {
        errMsg = data.message ?? data.errMsg;
      } else if (data instanceof ArrayBuffer) {
        try {
          const text = new TextDecoder('utf-8').decode(data);
          const json = JSON.parse(text);
          if (json?.message) errMsg = json.message;
        } catch (_) {}
      }
    }
    toasterMsg(typeof errMsg === 'string' ? errMsg : ERROR_MESSAGE, 'danger');
  }
};

export const downloadCostingExportSelected = (params, transactionMsg) => async () => {
  try {
    const serviceParams = {
      devOrderIds: params?.devOrderIds ?? [],
      costingTemplateId: params?.costingTemplateId ?? '',
      excludeProductImage: params?.excludeProductImage !== false,
    };
    if (Array.isArray(params?.costingIds) && params.costingIds.length > 0) {
      serviceParams.costingIds = params.costingIds;
    }
    if (params?.rangeplanId) {
      serviceParams.rangeplanId = params.rangeplanId;
    }
    const response = await ProductListService.costingExportSelectedService(serviceParams);
    if (response?.data) {
      const contentDisposition = response?.headers?.['content-disposition'] ?? response?.headers?.['Content-Disposition'];
      let fileName = `Costing_Report_Selected_${Date.now()}.xlsx`;
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^";\n]+)"?/);
        if (match?.[1]) fileName = match[1];
      }
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      fileSaver.saveAs(blob, fileName);
      toasterMsg(transactionMsg('Costing report downloaded successfully'), 'success');
    }
  } catch (error) {
    let errMsg = error?.message ?? ERROR_MESSAGE;
    const data = error?.response?.data;
    if (data) {
      if (typeof data === 'object' && !(data instanceof ArrayBuffer) && (data.message || data.errMsg)) {
        errMsg = data.message ?? data.errMsg;
      } else if (data instanceof ArrayBuffer) {
        try {
          const text = new TextDecoder('utf-8').decode(data);
          const json = JSON.parse(text);
          if (json?.message) errMsg = json.message;
        } catch (_) {}
      }
    }
    toasterMsg(typeof errMsg === 'string' ? errMsg : ERROR_MESSAGE, 'danger');
  }
};

export const downloadRanplanExcelSheet = (params, transactionMsg) => async () => {
  try {
    const res = await ProductListService.downloadRanplanExcelSheetService(params);
    if (params?.tabId === 'costing' && res?.data && res?.headers) {
      const contentType = res.headers['content-type'] || res.headers['Content-Type'] || '';
      if (contentType.indexOf('application/json') !== -1) {
        const decoder = new TextDecoder('utf-8');
        const text = typeof res.data === 'string' ? res.data : decoder.decode(new Uint8Array(res.data));
        let json;
        try {
          json = JSON.parse(text);
        } catch (_) {
          toasterMsg(ERROR_MESSAGE, 'danger');
          return null;
        }
        if (json?.code !== 200 && json?.message) {
          toasterMsg(json.message || ERROR_MESSAGE, 'danger');
          return null;
        }
        return null;
      }
      if (contentType.indexOf('spreadsheet') !== -1 || contentType.indexOf('octet-stream') !== -1) {
        const contentDisposition = res.headers['content-disposition'] || res.headers['Content-Disposition'];
        let fileName = 'Costing_Report.xlsx';
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^";\n]+)"?/);
          if (match && match[1]) fileName = match[1];
        }
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        toasterMsg(transactionMsg('Costing report downloaded successfully'), 'success');
        return res;
      }
    }
    if (res?.code === 500 || res?.data?.error) {
      if (res?.data?.error) {
        toasterMsg(`${transactionMsg(res?.data?.error.join(', '))}  download is in progress `, 'danger');
      } else {
        toasterMsg(transactionMsg(res.data.errMsg), 'danger');
      }
    } else if (res) {
      toasterMsg(transactionMsg(res.message), 'success');
      return res;
    }
  } catch (error) {
    console.log('errorerror', error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const updateDataBasedOnXlSXData = (data, transactionMsg) => async () => {
  try {
    const res = await ProductListService.updateDataBasedOnXlSXDataService(data);
    if (res?.code === 500) {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    } else if (res.code === 200) {
      toasterMsg(transactionMsg('Uploaded successfully'), 'success');
    }
    return res;
  } catch (error) {
    console.log('errorerror', error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveSupplierDefaultFactory = (params) => async () => {
  try {
    const res = await ProductListService.saveSupplierDefaultFactoryService(params);
    if (res.code === 200) {
      toasterMsg('Default Factory Updated', 'success');
    }
    return res;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getMultipleProductCosting = (params) => async () => {
  try {
    return await ProductListService.getMultipleProductCosting(params);
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const bulkExchangeRateUpdate = (params, t) => async () => {
  try {
    const res = await ProductListService.bulkExchangeRateUpdate(params);
    if (res.code === 200) {
      toasterMsg(t(res?.message), 'success');
    } else {
      toasterMsg(t(res?.message), 'danger');
    }
    return res;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const saveNote = (params, payload, transactionMsg) => async () => {
  try {
    const res = await OrderPermissionService.saveOrderPermission(params, payload);
    if (res?.code === 200) {
      const msg = transactionMsg(`RANGE_PLAN.${res.message}`);
      toasterMsg(msg, 'success');
    }
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getNote = (params) => async () => {
  try {
    const res = await OrderPermissionService.getOrderPermission(params);
    if (res?.code === 200) {
      return res.data;
    }
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchProductGroup = () => async (dispatch) => {
  try {
    const res = await ProductListService.getProductGroups();

    if (res.code === 200 && res.data) {
      await dispatch({
        type: ProductListType.PRODUCT_GROUP,
        payload: res.data,
      });
      return true;
    }
  } catch (err) {
    console.log('catch..', err);
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const autoSaveCustomSection = (data) => async () => {
  try {
    const res = await ProductListService.autoSaveCustomSectionService(data);
    if (res.code === 200) {
      return true;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const updateRangeplanProductList = (data) => async (dispatch) => {
  try {
    await dispatch({
      type: ProductListType.UPDATE_PRODUCT_LIST,
      payload: data,
    });
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const refreshCostingAction = (transactionMsg) => async () => {
  try {
    const res = await ProductListService.refreshCostingActionService();
    if (res.code === 200) {
      if (res?.message?.err) {
        toasterMsg(transactionMsg(res?.message?.msg), 'danger');
      } else {
        toasterMsg(transactionMsg('PURCHASE_ORDER.PO_DOCUMENT.BULK_UPDATE'), 'success');
      }
      return res;
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

/**
 * Downloads range plan sheets based on the specified data type and sheet name.
 *
 * @param {Object} data - The data object containing information about the sheet to be downloaded.
 * @param {string} data.type - The type of sheet to download ('sample', 'selected', or 'all').
 * @param {string} data.sheetName - The name of the sheet to be used in the file name.
 * @param {Function} t - A translation function is used for error messages in respective languages.
 * It call's a function which call's backend api for downloading the data based on the type.
 * Saves the downloaded file using file-saver and displays appropriate messages based on the response.
 * Handles errors by logging them and showing a danger toaster message.
 */

export const downloadRPSheets = (data, t) => async () => {
  try {
    const res = await ProductListService.exportRPExcelService(data);
    if (res) {
      if (data?.type === 'sample') {
        fileSaver.saveAs(res, `Sample ${data?.sheetName}`);
      } else if (data?.type === 'selected') {
        fileSaver.saveAs(res, `Selected ${data?.sheetName}`);
      } else {
        fileSaver.saveAs(res, `All ${data?.sheetName}`);
      }
    } else if (res?.data && res?.data?.errMsg) {
      toasterMsg(t(res?.data?.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(t(res?.message), 'danger');
    }
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

/**
 * Import products in the system by uploading an Excel sheet.
 *
 * @param {Object} params - The data object containing the file to be uploaded and extra parameters to pass to backend.
 * @param {Function} t - A translation function is used for error messages in respective languages.
 * It call's a function which call's backend api for importing the products based on the file uploaded.
 * Displays appropriate messages based on the response.
 * Handles errors by logging them and showing a danger toaster message.
 */
export const importProductsInSystem = (params, t) => async () => {
  try {
    const response = await ProductListService.importProductsExcelSheet(params);
    if (response && response.code === 200 && response.data && response?.data?.success) {
      toasterMsg(t(`RANGE_PLANS.${response.message}`), 'success');
    } else if (response && response.code === 200 && response.data && !response?.data?.success) {
      toasterMsg(t(`RANGE_PLANS.${response.message}`), 'success');
    } else {
      toasterMsg(t(response.data.errMsg), 'danger');
    }
    return response;
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const confirmIncludeDuplicatesUpload = (params) => async () => {
  try {
    return await ProductListService.confirmIncludeDuplicatesUpload(params);
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchRPProductInfoDetails = (params) => async (dispatch) => {
  try {
    const res = await ProductListService.getRPProductInformationList(params);
    if (res.code === 200 && res.data) {
      await dispatch({
        type: ProductListType.RP_PRODUCT_INFORMATION,
        payload: { data: res.data, params },
      });
      return true;
    }
    if (res.code === 500 || res.code === 400) {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
    return true;
  }
};

export const getRanglePlanLogs = (params) => async (dispatch) => {
  try {
    const res = await ProductListService.getRanglePlanLogs(params);
    if (res.code === 200 && res.data) {
      await dispatch({
        type: ProductListType.GET_RANGE_PLAN_LOGS,
        payload: res.data,
      });
      return true;
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearRangeLogs = () => async (dispatch) => {
  try {
    await dispatch({
      type: ProductListType.CLEAR_LOGS_REDUCER,
    });
  } catch (err) {
    console.log('............', err);
  }
};

export const deleteRanglePlanLogs = (params, transactionMsg) => async () => {
  try {
    const res = await ProductListService.deleteRanglePlanLogs(params);
    if (res.code === 200) {
      const msg = transactionMsg(`RANGEPLAN_CARD.${res?.data?.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

/**
 * BM-9586 — downloads the v2 upload's error sheet as soon as the response carries one.
 *
 * The server returns the rejected rows as a workbook with the same headers the user uploaded plus
 * an `Error` column, so they correct the cells in place and re-upload the same file. Saving it here
 * rather than behind a button is what makes that immediate; the error modal still shows the counts
 * and reasons on screen while the file lands.
 *
 * Delivered base64 on the response — no second round trip — and skipped entirely above the row cap,
 * where the server puts the sheet in S3 instead rather than inline a huge blob.
 *
 * @param {object} data Upload response payload.
 */
export const saveProductIdentifierErrorSheet = (data) => {
  const errorSheet = data?.errorSheet;
  if (!errorSheet) return;

  /*
   * The server URL is the delivery a browser reliably completes — the same `/assets` contract
   * every legacy importer's error file uses. A script-built blob download can be held back by the
   * browser pending a confirmation nobody sees, so the blob is only the fallback for a response
   * that carries no URL.
   */
  if (errorSheet.url) {
    const link = document.createElement('a');
    link.href = errorSheet.url;
    link.setAttribute('download', errorSheet.fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return;
  }

  if (!errorSheet.base64) return;
  const binary = window.atob(errorSheet.base64);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }

  fileSaver.saveAs(
    new Blob([bytes], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }),
    errorSheet.fileName,
  );
};

export const importProductIdentifierInSystem = (params, t) => async () => {
  try {
    const response = await ProductListService.importProductIdentifierExcelSheet(params);
    saveProductIdentifierErrorSheet(response?.data);
    if (response && response.code === 200 && response.data && response?.data?.success) {
      toasterMsg(t(`RANGE_PLANS.${response.message}`), 'success');
    } else if (response && response.code === 200 && response.data && !response?.data?.success) {
      toasterMsg(t(`RANGE_PLANS.${response.message}`), 'success');
    } else {
      toasterMsg(t(response.data.errMsg), 'danger');
    }
    return response;
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const uploadRPCustomSectionFileToS3 = (file, activeTab, sectionId, rangeplanId) => {
  return async () => {
    try {
      const urlResponse = await ProductListService.getRPCustomUploadPresignedUrl(file.name, activeTab, sectionId, rangeplanId);
      if (urlResponse?.code !== 200 || !urlResponse?.data?.presignedUrl) {
        return {
          success: false,
          message: urlResponse?.message || 'Failed to get upload URL',
        };
      }

      const { presignedUrl, s3Key } = urlResponse.data;
      const uploadResponse = await ProductListService.uploadFileToS3Direct(presignedUrl, file);
      if (!uploadResponse.success) {
        return {
          success: false,
          message: 'Failed to upload file to S3',
        };
      }

      return {
        success: true,
        s3Key,
        message: 'File uploaded successfully',
      };
    } catch (err) {
      console.error('uploadRPCustomSectionFileToS3 error:', err);
      return {
        success: false,
        message: err.message || 'Upload failed',
      };
    }
  };
};

export const unmountRPInformation = () => async (dispatch) => {
  try {
    await dispatch({
      type: ProductListType.RP_PRODUCT_INFORMATION_UNMOUNT,
    });
  } catch (err) {
    console.log('............', err);
  }
};

export const clearFilterSelectedData = () => async (dispatch) => {
  try {
    await dispatch({
      type: ProductListType.CLEAR_FILTER_SELECTED_DATA,
    });
  } catch (err) {
    console.log('Error clearing filter data:', err);
  }
};

export const fetchRangePlanCards = (params) => async (dispatch) => {
  try {
    dispatch({
      type: ProductListType.SET_RANGE_PLAN_CARD_LOADING,
      payload: true,
    });

    const res = await ProductListService.getRangePlanCards(params);
    if (res?.code === 200 && res?.data) {
      dispatch({
        type: ProductListType.SET_RANGE_PLAN_CARDS,
        payload: {
          data: res.data.doc || [],
          totalCount: res.data.totalCount || 0,
          isScrolled: params?.isScrolled || false,
        },
      });
      return res.data;
    }
    toasterMsg(res?.data?.errMsg || 'Failed to fetch range plan cards', 'danger');
  } catch (err) {
    console.error('Error fetching range plan cards:', err);
    toasterMsg(ERROR_MESSAGE, 'danger');
  } finally {
    dispatch({
      type: ProductListType.SET_RANGE_PLAN_CARD_LOADING,
      payload: false,
    });
  }
  return false;
};

export const createRangePlanCard = (params, t) => async (dispatch) => {
  try {
    dispatch({
      type: ProductListType.SET_RANGE_PLAN_CARD_LOADING,
      payload: true,
    });

    const res = await ProductListService.createRangePlanCard(params);
    if (res?.code === 200 && res?.data) {
      dispatch({
        type: ProductListType.ADD_RANGE_PLAN_CARD,
        payload: res.data,
      });
      toasterMsg(t?.('RANGEPLAN_CARD.CARD_CREATED_SUCCESS') || 'Range plan card created successfully', 'success');
      return res.data;
    }
    toasterMsg(res?.data?.errMsg || 'Failed to create range plan card', 'danger');
  } catch (err) {
    console.error('Error creating range plan card:', err);
    toasterMsg(ERROR_MESSAGE, 'danger');
  } finally {
    dispatch({
      type: ProductListType.SET_RANGE_PLAN_CARD_LOADING,
      payload: false,
    });
  }
  return false;
};

export const updateRangePlanCard = (params, t) => async (dispatch) => {
  try {
    dispatch({
      type: ProductListType.SET_RANGE_PLAN_CARD_LOADING,
      payload: true,
    });

    const res = await ProductListService.updateRangePlanCard(params);
    if (res?.code === 200 && res?.data) {
      dispatch({
        type: ProductListType.UPDATE_RANGE_PLAN_CARD,
        payload: res.data,
      });
      toasterMsg(t?.(`RANGEPLAN_CARD.${res.message}`) || 'Range plan card updated successfully', 'success');
      return res.data;
    }
    toasterMsg(res?.data?.errMsg || 'Failed to update range plan card', 'danger');
  } catch (err) {
    console.error('Error updating range plan card:', err);
    toasterMsg(ERROR_MESSAGE, 'danger');
  } finally {
    dispatch({
      type: ProductListType.SET_RANGE_PLAN_CARD_LOADING,
      payload: false,
    });
  }
  return false;
};

export const deleteRangePlanCards = (cardIds, t) => async (dispatch) => {
  try {
    const res = await ProductListService.deleteRangePlanCards({ cardIds });

    if (res?.code === 200) {
      dispatch({
        type: ProductListType.DELETE_RANGE_PLAN_CARD,
        payload: cardIds,
      });
      toasterMsg(t?.(res?.message) || 'Range plan cards deleted successfully', 'success');
      return true;
    }
    const errorMsg = res?.data?.errMsg || res?.message || 'Failed to delete range plan cards';
    toasterMsg(errorMsg, 'danger');
  } catch (err) {
    console.error('Error deleting range plan cards:', err);
    const errorMsg = err?.response?.data?.message || err?.message || ERROR_MESSAGE;
    toasterMsg(errorMsg, 'danger');
  }
  return false;
};

export const duplicateRangePlanCard = (params, dupRangeplanId, t) => async (dispatch) => {
  try {
    dispatch({
      type: ProductListType.SET_RANGE_PLAN_CARD_LOADING,
      payload: true,
    });

    const res = await ProductListService.duplicateRangePlanCard(params, dupRangeplanId);
    if (res?.code === 200 && res?.data) {
      dispatch({
        type: ProductListType.DUPLICATE_RANGE_PLAN_CARD,
        payload: res.data,
      });
      toasterMsg(t?.('RANGEPLAN_CARD.CARD_DUPLICATED_SUCCESS') || 'Range plan card duplicated successfully', 'success');
      return res.data;
    }
    toasterMsg(res?.data?.errMsg || 'Failed to duplicate range plan card', 'danger');
  } catch (err) {
    console.error('Error duplicating range plan card:', err);
    toasterMsg(ERROR_MESSAGE, 'danger');
  } finally {
    dispatch({
      type: ProductListType.SET_RANGE_PLAN_CARD_LOADING,
      payload: false,
    });
  }
  return false;
};

export const archiveUnarchiveRangePlanCard = (cardId, isArchive, archiveComment, t) => async (dispatch) => {
  try {
    const res = await ProductListService.archiveUnarchiveRangePlanCard({
      cardId,
      isArchive,
      archiveComment,
    });
    if (res?.code === 200) {
      dispatch({
        type: ProductListType.ARCHIVE_RANGE_PLAN_CARD,
        payload: { cardId, isArchive },
      });
      const message = isArchive
        ? t?.('RANGEPLAN_CARD.CARD_ARCHIVED_SUCCESS') || 'Range plan card archived successfully'
        : t?.('RANGEPLAN_CARD.CARD_UNARCHIVED_SUCCESS') || 'Range plan card unarchived successfully';
      toasterMsg(message, 'success');
      return true;
    }
    toasterMsg(res?.data?.errMsg || res?.message || 'Failed to archive/unarchive range plan card', 'danger');
  } catch (err) {
    console.error('Error archiving/unarchiving range plan card:', err);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return false;
};

export const archiveUnarchiveRangePlanCards = (cards, isArchive, t) => async (dispatch) => {
  try {
    const res = await ProductListService.archiveUnarchiveRangePlanCards({
      cards,
      isArchive,
    });
    if (res?.code === 200) {
      dispatch({
        type: ProductListType.ARCHIVE_RANGE_PLAN_CARDS,
        payload: { cardIds: cards.map((c) => c.cardId), isArchive },
      });
      const message = isArchive
        ? t?.('RANGEPLAN_CARD.CARDS_ARCHIVED_SUCCESS') || `${cards.length} range plan cards archived successfully`
        : t?.('RANGEPLAN_CARD.CARDS_UNARCHIVED_SUCCESS') || `${cards.length} range plan cards unarchived successfully`;
      toasterMsg(message, 'success');
      return true;
    }
    toasterMsg(res?.data?.errMsg || res?.message || 'Failed to archive/unarchive range plan cards', 'danger');
  } catch (err) {
    console.error('Error archiving/unarchiving range plan cards:', err);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return false;
};

export const pinUnpinRangePlanCard = (cardId, isPinned, t) => async (dispatch) => {
  try {
    const res = await ProductListService.pinUnpinRangePlanCard({
      cardId,
      isPinned,
    });
    if (res?.code === 200 && res?.data) {
      dispatch({
        type: ProductListType.PIN_RANGE_PLAN_CARD,
        payload: res.data,
      });
      const message = isPinned
        ? t?.('RANGEPLAN_CARD.CARD_PINNED_SUCCESS') || 'Range plan card pinned successfully'
        : t?.('RANGEPLAN_CARD.CARD_UNPINNED_SUCCESS') || 'Range plan card unpinned successfully';
      toasterMsg(message, 'success');
      return res.data;
    }
    toasterMsg(res?.data?.errMsg || 'Failed to pin/unpin range plan card', 'danger');
  } catch (err) {
    console.error('Error pinning/unpinning range plan card:', err);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return false;
};

export const activeInactiveRangePlanCard = (cardId, isActive, t) => async (dispatch) => {
  try {
    const res = await ProductListService.activeInactiveRangePlanCard({
      cardId,
      isActive,
    });
    if (res?.code === 200 && res?.data) {
      dispatch({
        type: ProductListType.ACTIVE_INACTIVE_RANGE_PLAN_CARD,
        payload: res.data,
      });
      const message = isActive
        ? t?.('RANGEPLAN_CARD.CARD_ACTIVATED_SUCCESS') || 'Range plan card activated successfully'
        : t?.('RANGEPLAN_CARD.CARD_DEACTIVATED_SUCCESS') || 'Range plan card deactivated successfully';
      toasterMsg(message, 'success');
      return res.data;
    }
    toasterMsg(res?.data?.errMsg || 'Failed to activate/deactivate range plan card', 'danger');
  } catch (err) {
    console.error('Error activating/deactivating range plan card:', err);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return false;
};

export const fetchRangePlanCardDetail = (cardId) => async (dispatch) => {
  try {
    dispatch({
      type: ProductListType.SET_RANGE_PLAN_CARD_LOADING,
      payload: true,
    });

    const res = await ProductListService.getRangePlanCardDetail(cardId);
    if (res?.code === 200 && res?.data) {
      dispatch({
        type: ProductListType.GET_RANGE_PLAN_CARD_DETAIL,
        payload: res.data,
      });
      return res.data;
    }
    toasterMsg(res?.data?.errMsg || 'Failed to fetch range plan card detail', 'danger');
  } catch (err) {
    console.error('Error fetching range plan card detail:', err);
    toasterMsg(ERROR_MESSAGE, 'danger');
  } finally {
    dispatch({
      type: ProductListType.SET_RANGE_PLAN_CARD_LOADING,
      payload: false,
    });
  }
  return false;
};

export const clearRangePlanCardDetail = () => (dispatch) => {
  dispatch({
    type: ProductListType.CLEAR_RANGE_PLAN_CARD_DETAIL,
  });
};

export const setRangePlanCardFilter = (filterData) => (dispatch) => {
  dispatch({
    type: ProductListType.SET_RANGE_PLAN_CARD_FILTER,
    payload: filterData,
  });
};

export const clearRangePlanCardFilter = () => (dispatch) => {
  dispatch({
    type: ProductListType.CLEAR_RANGE_PLAN_CARD_FILTER,
  });
};

export const clearRangePlanCards = () => (dispatch) => {
  dispatch({
    type: ProductListType.CLEAR_RANGE_PLAN_CARDS,
  });
};

/**
 * Replaces the ticked scopes for a single column. The reducer drops stale values for scopes
 * that are no longer ticked. Caller is responsible for following up with `fetchColumnTotals`
 * when a scope is being newly added.
 */
export const toggleColumnTotalScope = (columnId, scopes) => (dispatch) => {
  dispatch({
    type: ProductListType.TOGGLE_COLUMN_TOTAL_SCOPE,
    payload: { columnId, scopes },
  });
};

/**
 * Applies an optimistic delta (`newValue − oldValue`) to the `'all'` scope of one column.
 * `'active'` and `'selected'` scopes are client-side derived and update automatically.
 */
export const applyColumnTotalDelta =
  ({ columnId, delta }) =>
  (dispatch) => {
    dispatch({
      type: ProductListType.APPLY_COLUMN_TOTAL_DELTA,
      payload: { columnId, delta },
    });
  };

/**
 * Batched fetch for the 'all' scope only. active and selected are computed client-side
 * from currently-loaded rows, so this action filters them out before hitting the network.
 */
export const fetchColumnTotals =
  ({ rangeplanId, requests, filters = null }) =>
  async (dispatch) => {
    if (!rangeplanId || !Array.isArray(requests) || requests.length === 0) return;
    const allRequests = requests
      .map((request) => ({
        columnId: request.columnId,
        scopes: (request.scopes || []).filter((scope) => scope === 'all'),
      }))
      .filter((request) => request.scopes.length > 0);
    if (allRequests.length === 0) return;
    const columnIds = allRequests.map((request) => request.columnId);
    dispatch({ type: ProductListType.SET_COLUMN_TOTALS_LOADING, payload: { columnIds, loading: true } });
    try {
      const res = await ProductListService.getColumnTotalsService({ rangeplanId, requests: allRequests, filters });
      if (res?.code === 200 && res?.data?.totals) {
        dispatch({ type: ProductListType.SET_COLUMN_TOTALS_SUCCESS, payload: { totals: res.data.totals } });
      } else {
        dispatch({ type: ProductListType.SET_COLUMN_TOTALS_LOADING, payload: { columnIds, loading: false } });
        toasterMsg(res?.data?.errMsg || ERROR_MESSAGE, 'danger');
      }
    } catch (err) {
      console.error('fetchColumnTotals error:', err);
      dispatch({ type: ProductListType.SET_COLUMN_TOTALS_LOADING, payload: { columnIds, loading: false } });
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
  };
